import React, { useState, useEffect } from 'react';
import { useApp } from '../../../context/AppContext';
import { ReactComponent as SaludationSvg } from '../../../assets/saludation.svg';

function ProfileContent({ fromLogin }) {
  const { user } = useApp();
  const [userData, setUserData] = useState({
    fullName: '',
    cpf: '',
    birthDate: '',
    cep: '',
    address: '',
    number: '',
    complement: '',
    phone: '',
    school: '',
    schoolYear: '',
    desiredFaculties: '',
    desiredCourses: '',
    email: '',
    password: '********',
    instituicao: '',
    matricula: '',
    modalidade: ''
  });

  const userID = user?.ID_usuario;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`https://rveducacao.com.br/get.php?action=getCadastro&ID_usuario=${userID}`);
        const data = await response.json();

        
        if (data.length > 0) {
          const user = data[0];

          setUserData({
            fullName: user.nome || '',
            cpf: user.CPF || '',
            birthDate: user.nascimento || '',
            cep: user.CEP || '',
            address: user.addr_logradouro || '',
            number: user.addr_numero || '',
            complement: user.addr_complemento || '',
            phone: user.celular || '',
            school: user.instituicao || '',
            schoolYear: user.user_group || '',
            desiredFaculties: '',
            desiredCourses: '',
            email: user.email || '',
            password: '********',
            instituicao: user.instituicao || '',
            matricula: user.matricula || '',
            modalidade: user.modalidade || ''
          });
        }
      } catch (error) {
        console.error('Erro ao buscar os dados do usuário:', error);
      }
    };

    if (userID) {
      fetchUserData();
    }
  }, [userID]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSendEmail = () => {
    const email = 'suporte@rv.com';
    const subject = 'Solicitação de Atualização de Dados';
    const body = `
      Nome Completo: ${userData.fullName}
      CPF: ${userData.cpf}
      Data de Nascimento: ${userData.birthDate}
      CEP: ${userData.cep}
      Endereço: ${userData.address}, ${userData.number} (${userData.complement})
      Celular: ${userData.phone}
      Instituição: ${userData.instituicao}
      Matrícula: ${userData.matricula}
      Modalidade: ${userData.modalidade}
      Ano do Colégio: ${userData.schoolYear}
      Email: ${userData.email}
    `;

    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, '_blank');
  };

  return (
    <div className={`perfil-profile-page-container ${fromLogin ? 'login' : ''}`}>
      {fromLogin ? (
        <div className='perfil-user-info first'>
          <h2 className='perfil-saludation-hey'>Olá, {userData.fullName.split(' ')[0] || 'Usuário'}!</h2>
          <SaludationSvg className='perfil-saludation-svg profile' />
        </div>
      ) : (
        <div className='perfil-user-info-logged'>
          <form className='perfil-user-logged' onSubmit={(e) => e.preventDefault()}>
            <h2 className='perfil-saludation-hey'>Olá, {userData.fullName.split(' ')[0] || 'Usuário'}!</h2>
            <p>Confira seus dados pessoais</p>

            <h3>Dados Pessoais</h3>
            <input type="text" name="fullName" placeholder="Nome Completo" value={userData.fullName} onChange={handleChange} />
            <input type="text" name="cpf" placeholder="CPF" value={userData.cpf} onChange={handleChange} />
            <input type="date" name="birthDate" placeholder="Data de Nascimento" value={userData.birthDate} onChange={handleChange} />
            <input type="text" name="cep" placeholder="CEP" value={userData.cep} onChange={handleChange} />
            <input type="text" name="address" placeholder="Endereço" value={userData.address} onChange={handleChange} />
            <input type="text" name="number" placeholder="Número" value={userData.number} onChange={handleChange} />
            <input type="text" name="complement" placeholder="Complemento" value={userData.complement} onChange={handleChange} />
            <input type="text" name="phone" placeholder="Celular" value={userData.phone} onChange={handleChange} />

            <h3>Histórico Escolar</h3>
            <input type="text" name="instituicao" placeholder="Instituição" value={userData.instituicao} onChange={handleChange} />
            <input type="text" name="matricula" placeholder="Matrícula" value={userData.matricula} readOnly />
            <input type="text" name="modalidade" placeholder="Modalidade" value={userData.modalidade} onChange={handleChange} />
            <input type="text" name="schoolYear" placeholder="Ano do Colégio" value={userData.schoolYear} onChange={handleChange} />
            {/* <input type="text" name="desiredFaculties" placeholder="Faculdade(s) Desejada(s)" value={userData.desiredFaculties} onChange={handleChange} /> */}
            {/* <input type="text" name="desiredCourses" placeholder="Curso(s) Desejado(s)" value={userData.desiredCourses} onChange={handleChange} /> */}

            <h3>Informações de Acesso</h3>
            <input type="text" name="email" placeholder="Email" value={userData.email} onChange={handleChange} />
            <input type="password" name="password" placeholder="Senha" value={userData.password} onChange={handleChange} />

            <button className='button' type="button" onClick={handleSendEmail}>
              Solicitar Alterações
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default ProfileContent;
